function ValidateQuota(selectedQuota) {
	var validationErrors = [];                
	if (!selectedQuota.name || selectedQuota.name === '') {                    
		addErrorMessage(validationErrors, 'name', 'Quota name is empty');
	}	
	
	return validationErrors;
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateQuota;